import { render, staticRenderFns } from "./configHigienizacion.vue?vue&type=template&id=87ef05b2"
import script from "./configHigienizacion.vue?vue&type=script&lang=js"
export * from "./configHigienizacion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports